var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcn20(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e23038;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63,61.07V28.42a1.65,1.65,0,0,0-1.65-1.65H54.67A1.65,1.65,0,0,0,53,28.42V59.79H49.87V35a1.64,1.64,0,0,0-1.64-1.65H41.5A1.64,1.64,0,0,0,39.86,35V59.79H36.72V35a1.64,1.64,0,0,0-1.64-1.65H28.35A1.64,1.64,0,0,0,26.71,35V59.79H23.49V44.87a1.64,1.64,0,0,0-1.65-1.64H15.12a1.64,1.64,0,0,0-1.65,1.64V59.79H10.21V8.57a1.65,1.65,0,1,0-3.29,0V61.43a1.65,1.65,0,0,0,1.65,1.65H61.43A1.64,1.64,0,0,0,63,61.07ZM20.2,59.79H16.76V46.52H20.2Zm13.23,0H30V36.65h3.43Zm13.15,0H43.15V36.65h3.43Zm13.17,0H56.31V30.06h3.44ZM17.23,36a1.66,1.66,0,0,1,.33-2.31l13.17-9.87c.78-.58.62-.21,13.45-.33l9.88-9.87H51.57a1.65,1.65,0,1,1,0-3.29H58A1.65,1.65,0,0,1,59.67,12v6.59a1.65,1.65,0,0,1-3.29,0V15.94L46,26.29a1.64,1.64,0,0,1-1.16.48H32.26L19.53,36.32A1.65,1.65,0,0,1,17.23,36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 70,
    height: 70
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn20);
export default __webpack_public_path__ + "static/media/icn_20.b940ee32b2bfc729f4796939552079fc.svg";
export { ForwardRef as ReactComponent };